import {Component, inject, input, output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataService} from '../../../services/store/data.service';
import {SpecificWorkingTimesFormComponent} from './specific-working-times-form/specific-working-times-form.component';
import {
  SpecificWorkingTimesDeleteComponent
} from './specific-working-times-delete/specific-working-times-delete.component';
import {StoreSpecialWorkingTime} from '../../../classes/models/store/StoreSpecialWorkingTime';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

/**
 * This handles displaying and editing special working times.
 */
@Component({
  selector: 'app-specific-working-times',
  templateUrl: './specific-working-times.component.html',
  styleUrls: ['./specific-working-times.component.less'],
  imports: [SHARED_IMPORTS]
})
export class SpecificWorkingTimesComponent {
  private modalService = inject(NgbModal);
  dataService = inject(DataService);

  /** An identifier of a store. */
  readonly storeId = input<string>(undefined);
  /** Store special working times */
  readonly workingTimes = input<StoreSpecialWorkingTime[]>([]);
  /** An event to refresh store page data. */
  readonly getStoreDetailsEvent = output();

  /**
   * Checks if data can be edited at the given date.
   * @param date the date on which data might be edited.
   */
  canEditAtDate(date: string): boolean {
    return this.dataService.canEditAtDate(date);
  }

  /**
   * Opens a modal window to create a new specific working time.
   */
  openCreate(): void {
    const modalRef = SpecificWorkingTimesFormComponent.open(this.modalService, {
      storeId: this.storeId()!,
      previousSpecialWorkingTime: undefined,
      weekExists: false
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a modal window to update existing specific working time.
   * @param specialWorkingTime special working time to be updated.
   */
  openUpdate(specialWorkingTime: StoreSpecialWorkingTime): void {
    const modalRef = SpecificWorkingTimesFormComponent.open(this.modalService, {
      storeId: this.storeId()!,
      previousSpecialWorkingTime: specialWorkingTime,
      weekExists: true
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }

  /**
   * Opens a modal to delete an existing special working time.
   * @param date a date on which a special working time should be deleted.
   */
  openDelete(date: string): void {
    const modalRef = SpecificWorkingTimesDeleteComponent.open(this.modalService, {
      storeId: this.storeId(),
      date
    });
    modalRef.result.then(() => {
      this.getStoreDetailsEvent.emit();
    });
  }
}